import React from 'react'
import SigninForm from '../Components/Authentication/SigninForm'

const LoginPage = () => {
  return (
    <main className='container d-flex align-items-center justify-content-center vh-100'>
      <SigninForm></SigninForm>
    </main>
  )
}

export default LoginPage